import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. We'll be in touch soon.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Could not send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-12 py-16">
      <div className="text-[11px] uppercase tracking-[0.3em] text-emerald-800 font-semibold">Contact</div>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-stone-900">Tell us how we can help.</h1>
      <p className="mt-3 font-sans text-stone-600 max-w-xl">
        Questions about farming on the platform, wholesale onboarding, or driver routes? Send us a note — a real person reads every one.
      </p>

      <form onSubmit={submit} className="mt-10 grid gap-5 bg-white border border-stone-200 p-8 rounded-md">
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Name</label>
            <Input data-testid="contact-name" required value={form.name} onChange={set("name")} className="mt-2 bg-stone-50 border-stone-200" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Email</label>
            <Input data-testid="contact-email" required type="email" value={form.email} onChange={set("email")} className="mt-2 bg-stone-50 border-stone-200" />
          </div>
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Subject</label>
          <Input data-testid="contact-subject" required value={form.subject} onChange={set("subject")} className="mt-2 bg-stone-50 border-stone-200" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Message</label>
          <Textarea data-testid="contact-message" required rows={6} value={form.message} onChange={set("message")} className="mt-2 bg-stone-50 border-stone-200" />
        </div>
        <div>
          <Button data-testid="contact-submit" disabled={sending} className="bg-emerald-800 hover:bg-emerald-700 text-stone-50 px-7 py-6 rounded-md">
            {sending ? "Sending..." : "Send Message"}
          </Button>
        </div>
      </form>
    </div>
  );
}
